import React, { ReactNode, useState } from "react";
import TranslatableText from "../Multilanguage/TranslatableText";
import { useTranslation } from "react-i18next";

type Props = {
  children?: ReactNode;
  value?: string;
};

const TextVisualizer = ({ children, value = "280" }: Props) => {
  const [cut, setCut] = useState(true);
  const { t } = useTranslation();

  return (
    <div className="">
      <div className="font-body w-full">
        {cut ? (
          <TranslatableText
            className=""
            text={children ? children.toString().slice(0, parseInt(value)) : ""}
            format="html"
            style={{
              width: "100%",
              wordBreak: "break-word",
              overflow: "hidden",
              whiteSpace: "break-spaces",
            }}
          />
        ) : (
          // <div
          // style={{width: "100%", wordBreak:"break-word", overflow:"hidden", whiteSpace:"break-spaces"}}
          //   className=""
          //   dangerouslySetInnerHTML={{
          //     __html: children
          //       ? children.toString().slice(0, parseInt(value))
          //       : "",
          //   }}
          // />
          <TranslatableText
            className=""
            text={children ? children.toString() : ""}
            format="html"
            style={{
              width: "100%",
              wordBreak: "break-word",
              overflow: "hidden",
              whiteSpace: "break-spaces",
            }}
          />
        )}
      </div>
      <div className="flex justify-end">
        {children && children.toString().length > parseInt(value) ? (
          <span
            className="cursor-pointer text-lavanda underline flex items-center gap-2"
            onClick={(e) => setCut((prev) => !prev)}
          >
            {cut ? t("viewMore") : t("viewLess")}
            {cut ? (
              <span>
                <svg
                  width="19"
                  height="10"
                  viewBox="0 0 19 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L9.5 9L18 1"
                    stroke="#645ABE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            ) : (
              <span>
                <svg
                  width="19"
                  height="10"
                  viewBox="0 0 19 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 9L9.5 1L18 9"
                    stroke="#645ABE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </span>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default TextVisualizer;
